import { render } from "./ProductCard.vue?vue&type=template&id=7e523a73&scoped=true&ts=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"

import "./ProductCard.vue?vue&type=style&index=0&id=7e523a73&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e523a73"],['__file',"src/components/cards/ProductCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e523a73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e523a73', __exports__)) {
    api.reload('7e523a73', __exports__)
  }
  
  module.hot.accept("./ProductCard.vue?vue&type=template&id=7e523a73&scoped=true&ts=true", () => {
    api.rerender('7e523a73', render)
  })

}


export default __exports__